import React from "react";
import { Box } from "@mui/material";
import { connect } from "react-redux";
import qs from "qs-lite";

import { getUserLocation } from "../../redux";
import { FOUNDRIES } from "../../constants";

const ReportsPageContent = ({ url, locationId = 1 }) => {
  if (!url) return <></>;

  const foundry = FOUNDRIES.find(({ id }) => id === locationId)?.label;
  const query = qs.stringify({ p_Location: foundry });
  const src = `${url}&${query}`;

  return (
    <Box
      component="iframe"
      src={src}
      sx={{
        width: "100%",
        border: "none",
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  locationId: getUserLocation(state),
});

export default connect(mapStateToProps)(ReportsPageContent);
